// URL routing configuration for English and German versions
export const routes = {
  en: {
    home: '/',
    about: '/about',
    services: '/services',
    cases: '/cases',
    caseDetail: '/cases/:slug',
    contact: '/contact',
    imprint: '/imprint',
    privacy: '/privacy',
    terms: '/terms'
  },
  de: {
    home: '/de',
    about: '/de/wer-ist-pik',
    services: '/de/was-wir-machen',
    cases: '/de/projekte',
    caseDetail: '/de/projekte/:slug',
    contact: '/de/kontakt',
    imprint: '/de/impressum',
    privacy: '/de/datenschutz',
    terms: '/de/agb'
  }
};

// Helper function to get route by language (supports :slug param)
export const getRoute = (key, lang = 'en', params = {}) => {
  let route = routes[lang][key];
  Object.keys(params).forEach((param) => {
    route = route.replace(`:${param}`, params[param]);
  });
  return route;
};

// Detect language from URL path
export const getLanguageFromPath = (pathname) => {
  if (pathname === '/de' || pathname.startsWith('/de/')) return 'de';
  return 'en';
};

// Find route key from a given pathname
const findRouteKey = (pathname, lang) => {
  const entries = Object.entries(routes[lang]);
  // Sort by specificity (longer paths first) to avoid '/' matching everything
  entries.sort((a, b) => b[1].length - a[1].length);

  for (const [key, value] of entries) {
    const pattern = '^' + value.replace(':slug', '[^/]+') + '$';
    const regex = new RegExp(pattern);
    if (regex.test(pathname)) return key;
  }
  return null;
};

// Get the corresponding URL in the other language
export const getAlternateUrl = (pathname, targetLang) => {
  const currentLang = getLanguageFromPath(pathname);
  if (currentLang === targetLang) return pathname;

  // Handle case detail pages explicitly (preserve slug)
  const isCaseDetail =
    (currentLang === 'en' && pathname.startsWith('/cases/')) ||
    (currentLang === 'de' && pathname.startsWith('/de/projekte/'));

  if (isCaseDetail) {
    const slug = pathname.split('/').pop();
    return getRoute('caseDetail', targetLang, { slug });
  }

  const routeKey = findRouteKey(pathname, currentLang);
  if (routeKey) return routes[targetLang][routeKey];

  // Fallback: language home
  return routes[targetLang].home;
};
